import React from 'react';
import { Typography, Box, useMediaQuery } from '@mui/material';
import { useTheme } from '@mui/material/styles';

const HeadersTab = () => {
    const theme = useTheme();
    const isMediumScreen = useMediaQuery(theme.breakpoints.down('md'));
    return (
        <Box>
            <Typography variant="h6" gutterBottom>Request Headers</Typography>
            <Typography variant="body1">
                Customize headers such as <code>Content-Type</code>, <code>Authorization</code>,
                and custom headers. These are sent along with your request and are crucial
                for APIs that require tokens or specific content types.
            </Typography>
            <img
                src="/send-requests/Headers.png"
                alt="Validations in HawkClient"
                style={{
                    width: isMediumScreen ? '100%' : '60%',
                    height: 'auto',
                    display: 'block',
                    objectFit: 'contain',
                    marginTop: '16px',
                    alignSelf: 'start',
                }}
            />
        </Box>
    )
};

export default HeadersTab;
